import firebase from 'firebase/app';
export function emitPageViewEvent(location, title) {
    firebase.analytics().logEvent('page_view', {
        page_location: location.href,
        page_path: location.pathname,
        page_title: title
    });
}
export function emitExceptionEvent(e) {
    firebase.analytics().logEvent('exception', {
        description: e.message
    });
}
export function emitHttpExceptionEvent(e) {
    firebase.analytics().logEvent('exception', {
        code: e.code,
        fatal: e.code === 'internal',
        description: e.message,
        details: e.details
    });
}
export function getBasicPostcardItem(order) {
    let originalPrice = 0;
    let promoCode = '';
    if (!order) {
        emitExceptionEvent(new Error('Exception while emitting getBasicPostcardItem. order is null'));
    }
    else {
        originalPrice = order.originalPrice;
        promoCode = order.promoCode;
    }
    return {
        item_id: 'basic',
        item_name: 'Basic Postcard',
        quantity: 1,
        price: originalPrice / 100,
        coupon: promoCode
    };
}
export function getBasicPostcardDetails(order) {
    let price = 0;
    if (!order) {
        emitExceptionEvent(new Error('Exception while emitting getBasicPostcardDetails. order is null'));
    }
    else {
        price = order.price;
    }
    return {
        currency: 'USD',
        value: price / 100,
        items: [getBasicPostcardItem(order)]
    };
}
